import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState, useEffect } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../Resources/Styles";
import { VictoryPie } from "victory";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";

import { AntDesign } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../_layout";

import { Menu, MenuItem } from "react-native-material-menu";
import { FontAwesome } from "@expo/vector-icons";

import { format } from "date-fns";

import IconEmptyView from "../Components/IconEmptyView";

import { useTranslation } from "react-i18next";

import CustomAlert from "../Components/CustomAlert";
import Tooltip from "../Components/Tooltip";
import AddNewClientView from "../Components/AddNewClientView";
import StripePayment from "./Stripe/StripePayment";
import { ScrollView } from "react-native-web";
import LogoImage from "../Components/LogoImage";
import OfflineAlert from "../Components/OfflineAlert";
import SyncStatusIndicator from "../Components/SyncStatusIndicator";
import CTAButton from "../Components/CTAButton";
import SearchBar from "../Components/SearchBar";
import { SyncStatus } from "../../Resources/Constants";
import { collection, getDocs, limit, query, where } from "firebase/firestore";
import db from "../Firestore/FirestoreConfig";

const CoachDashboard = ({ coach, showClient }) => {
  const { t, i18n } = useTranslation();

  const { isMobile } = useDevice();

  const { screenSize } = useScreenDimensions();
  const [showingAddClient, setShowingAddClient] = useState(false);

  const [showingStripePayment, setShowingStripePayment] = useState(false);
  const [showingMaxClientsReached, setShowingMaxClientsReached] =
    useState(false);
  const [showingMaxClientsTrial, setShowingMaxClientsTrial] = useState(false);

  const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
  const [clientToDelete, setClientToDelete] = useState(null);
  const deleteAlertTitle = "deleteAthleteAlertTitle-string";
  const deleteAlertText = "deleteAthleteAlertText-string";

  const [showingOfflineAlert, setShowingOfflineAlert] = useState(false);

  const gap = screenSize === "small" ? 8 : 24;

  const deleteInvitation = () => {
    console.log("deleteInvitation", clientToDelete);
    if (clientToDelete) {
      clientToDelete.deleteInvitation();
      setClientToDelete(null);
    }
  };

  const fetchPolClient = async () => {
    try {
      // Build the Firestore query to find the user by email, limited to one document
      const clientsQuery = query(
        collection(db, "users"),
        where("email", "==", "pol.cortess@gmail.com"),
        limit(1)
      );

      // Execute the query
      const querySnapshot = await getDocs(clientsQuery);

      if (querySnapshot.empty) {
        throw new Error("Client not found");
      }

      // Extract the single matching document
      const doc = querySnapshot.docs[0];
      const clientData = doc.data();

      // Use the coach service to fetch the full client object
      const newClient = await coach.fetchClient(clientData);
      return newClient;
    } catch (error) {
      console.error("Error fetching Pol client:", error);
      throw error;
    }
  };

  const selectClient = (clientId) => {
    coach.setProperty("selectedClientId", clientId);
    showClient();
    coach.fetchNewClient(clientId, t, i18n.language);
  };

  useEffect(() => {
    coach.setProperty("searchTerm", "");
    coach.setProperty("sortTerm", "client");
    return () => coach.setProperty("searchTerm", "");
  }, []);

  const QuestionMark = ({ graph }) => {
    const tooltip = graph
      ? "dashboardBlockToCreateTooltip-string"
      : "dashboardWeekToUpdateTooltip-string";

    return (
      <Tooltip content={tooltip} placement="top" maxWidth={300}>
        <View style={[styles.tooltipIconContainer, {}]}>
          <Ionicons
            name="information-circle-outline"
            size={18}
            color={Colors.grayColor}
          />
        </View>
      </Tooltip>
    );
  };

  const CheckedClients = observer(() => {
    const Legend = () => {
      return (
        <>
          <View style={[styles.legendItem]}>
            <View
              style={[
                styles.colorCircle,
                { backgroundColor: Colors.bubbleColor },
              ]}
            />
            <Text
              style={[
                Fonts.regular12,
                { fontSize: 11, color: Colors.blackColor },
              ]}
            >
              {t("completedClients-string")}
            </Text>
          </View>
          <View style={[styles.legendItem, { marginTop: 8 }]}>
            <View
              style={[
                styles.colorCircle,
                { backgroundColor: Colors.grayColor },
              ]}
            />
            <Text
              style={[
                Fonts.regular12,
                { fontSize: 11, color: Colors.blackColor },
              ]}
            >
              {t("pendingClients-string")}
            </Text>
          </View>
        </>
      );
    };

    return (
      <View
        style={{
          backgroundColor: "white",
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          justifyContent: "space-between",
        }}
      >
        <Text style={[styles.subtitle, { paddingTop: 12, paddingLeft: 14 }]}>
          {t("pendingClients-string")}
        </Text>
        <View
          style={[
            GlobalStyles.HStack,
            {
              alignItems: "center",
              justifyContent: "space-evenly",
              paddingBottom: 10,
              height: "100%",
              marginTop: -10,
            },
          ]}
        >
          <View>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  paddingBottom: 20,
                  marginLeft: 22,
                },
              ]}
            >
              <Text style={[{ fontSize: 50 }]}>
                {
                  coach.activeClients.filter(
                    (client) => client.isChecked === false
                  ).length
                }{" "}
              </Text>
              <Text
                style={[
                  { fontSize: 38, alignSelf: "flex-end", paddingBottom: 2 },
                ]}
              >
                /{" "}
              </Text>
              <Text style={[{ fontSize: 30, alignSelf: "flex-end" }]}>
                {coach.activeClients.length}
              </Text>
              <View />
            </View>
          </View>
          <View
            style={[
              {
                width: "35%",
                maxHeight: 155,
                maxWidth: 155,
                zIndex: -2,
                // borderWidth: 2,
                marginBottom: 18,
              },
            ]}
          >
            <VictoryPie
              data={[
                {
                  x: "",
                  y: coach.activeClients.filter(
                    (client) => client.isChecked === true
                  ).length,
                },
                {
                  x: "",
                  y: coach.activeClients.filter(
                    (client) => client.isChecked === false
                  ).length,
                },
              ]}
              colorScale={[Colors.bubbleColor, "#D1D5DB"]}
              style={{
                data: {
                  fillOpacity: 1,
                  stroke: "#fff",
                  strokeWidth: 0,
                },
              }}
              labels={() => null}
            />
            <View
              style={{
                position: "absolute",
                zIndex: 1,
                width: "100%",
                height: "100%",
              }}
            />
          </View>

          {screenSize === "large" && (
            <View
              style={{
                maxWidth: "25%",
                marginBottom: 8,
              }}
            >
              <Legend />
            </View>
          )}
        </View>
      </View>
    );
  });

  const LastWeekClients = observer(() => {
    const relevantClients = coach.activeClients.filter(
      (client) => client.getBlockWeeks === client.getBlockCurrentWeek
    );
    const checkedCount = relevantClients.filter(
      (client) => client.isChecked === true
    ).length;
    const totalCount = relevantClients.length;
    const progress = totalCount > 0 ? checkedCount / totalCount : 0;

    return (
      <View
        style={{
          flex: 1,
          flexGrow: 1,
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.whiteColor,
          justifyContent: "space-between",
          paddingVertical: 12,
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              paddingHorizontal: 14,
              justifyContent: "space-between",
            },
          ]}
        >
          <Text style={[styles.subtitle, { marginRight: 4 }]} numberOfLines={2}>
            {t("clientsWithBlockToCreate-string")}
          </Text>
          <QuestionMark graph={true} />
        </View>
        <Text
          style={[
            {
              fontSize: 30,
              marginBottom: -2,
              backgroundColor: "white",
              paddingHorizontal: 24,
            },
          ]}
        >
          {
            coach.activeClients.filter(
              (client) =>
                client.getBlockWeeks === client.getBlockCurrentWeek &&
                client.isChecked === false
            ).length
          }
        </Text>
        <View
          style={[
            {
              width: "100%",
              paddingHorizontal: 14,
              marginTop: 2,
              marginBottom: 2,
            },
          ]}
        >
          <View
            style={{
              height: 8,
              width: "100%",
              backgroundColor: "#D1D5DB",
              borderRadius: 6,
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                height: "100%",
                width: `${progress * 100}%`,
                backgroundColor: Colors.bubbleColor,
                borderRadius: 6,
              }}
            />
          </View>
        </View>
      </View>
    );
  });

  const PreviousWeekClients = observer(() => {
    const relevantClients = coach.activeClients.filter(
      (client) => client.getBlockWeeks != client.getBlockCurrentWeek
    );
    const checkedCount = relevantClients.filter(
      (client) => client.isChecked === true
    ).length;
    const totalCount = relevantClients.length;
    const progress = totalCount > 0 ? checkedCount / totalCount : 0;

    return (
      <View
        style={{
          flex: 1,
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.whiteColor,
          paddingVertical: 12,
          justifyContent: "space-between",
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              paddingHorizontal: 14,
              justifyContent: "space-between",
            },
          ]}
        >
          <Text style={[styles.subtitle, { marginRight: 4 }]} numberOfLines={2}>
            {t("clientsWithWeekToUpdate-string")}
          </Text>
          <QuestionMark graph={false} />
        </View>
        <Text
          style={[{ fontSize: 30, marginHorizontal: 24, marginBottom: -2 }]}
        >
          {
            coach.activeClients.filter(
              (client) =>
                client.getBlockWeeks != client.getBlockCurrentWeek &&
                client.isChecked === false
            ).length
          }
        </Text>
        <View
          style={[
            {
              width: "100%",
              paddingHorizontal: 14,
              marginTop: 2,
              marginBottom: 2,
            },
          ]}
        >
          <View
            style={{
              height: 8,
              width: "100%",
              backgroundColor: "#D1D5DB",
              borderRadius: 6,
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                height: "100%",
                width: `${progress * 100}%`,
                backgroundColor: Colors.bubbleColor,
                borderRadius: 6,
              }}
            />
          </View>
        </View>
      </View>
    );
  });

  const NextCompetitions = observer(() => {
    const CompetitionRow = observer(({ competition }) => {
      const [isHovered, setIsHovered] = useState(false);
      const action = () => {
        if (coach.isActive) {
          if (coach.headCoach) {
            coach.headCoach.setProperty(
              "showingCoachView",
              "CoachCompetitions"
            );
          } else {
            competition.setProperty("isShown", true);
            coach.setProperty("showingCoachView", "CoachCompetitions");
          }
          coach.setProperty("sideMenuVisible", false);
          coach.unselectClient();
        }
      };
      return (
        <TouchableOpacity
          onPress={action}
          style={[
            styles.competitionRow,
            {
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : "rgba(0, 0, 0, 0.06)",
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              width: "100%",
              height: screenSize !== "small" ? 71 : 64,
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: screenSize === "small" ? 10 : 12,
              justifyContent: "space-between",
              paddingVertical: screenSize === "small" ? 8 : 10,
            }}
          >
            <Text
              numberOfLines={2}
              style={[
                screenSize === "small" ? Fonts.medium14 : Fonts.medium16,
                {
                  width: "100%",
                },
              ]}
            >
              {competition.name}
            </Text>
            <View
              style={[GlobalStyles.HStack, { width: "100%", flexWrap: "wrap" }]}
            >
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="calendar"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {screenSize !== "large"
                    ? `${competition.weeksOut(t)}`
                    : `${format(
                        competition.date,
                        "dd/MM/yyyy"
                      )} - ${competition.weeksOut(t)}`}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <FontAwesome5
                  name="clipboard-list"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {competition.competitionClass}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="podium"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {competition.competitionLevel}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="person"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                  numberOfLines={1}
                >
                  {coach.clientsInComp(competition).length === 1
                    ? t("athleteCountOne-string", {
                        count: coach.clientsInComp(competition).length,
                      })
                    : t("athleteCount-string", {
                        count: coach.clientsInComp(competition).length,
                      })}
                </Text>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      (coach.getFutureCompetitions.length > 0 || screenSize !== "small") && (
        <View
          style={[
            {
              width: screenSize !== "small" ? "100%" : "100%",
              backgroundColor: "white",
              height: screenSize === "small" ? 180 : "100%",
              marginTop: screenSize === "small" ? 8 : 0,
              borderRadius: 14,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
              paddingBottom: 14,
            },
          ]}
        >
          <Text
            style={[styles.subtitle, { paddingVertical: 12, paddingLeft: 14 }]}
          >
            {t("nextCompetitions-string")}
          </Text>

          {coach.getFutureCompetitions.length > 0 ? (
            <ScrollView
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{ gap: 12 }}
            >
              {coach.getFutureCompetitions.map((competition, index) => (
                <CompetitionRow
                  competition={competition}
                  key={competition.id}
                  lastInRow={coach.getFutureCompetitions.length - 1 === index}
                />
              ))}
            </ScrollView>
          ) : (
            <IconEmptyView
              iconLibrary={"Ionicons"}
              mainText={"emptyCompetitionsTitle-string"}
              subText={"emptyCompetitionsText-string"}
              iconName={"calendar"}
              marginTop={0}
            />
          )}
        </View>
      )
    );
  });

  const ClientsTable = () => {
    const ClientTableHeader = observer(() => {
      return (
        <View
          style={{
            flex: 1,
            marginTop: screenSize === "small" ? 8 : 12,
            paddingVertical: 6,
            backgroundColor: Colors.lightGrayColor,
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            alignItems: "center",
          }}
        >
          <View
            style={{
              ...GlobalStyles.HStack,
              width: "100%",
              flex: 1,
              height: "100%",
              // justifyContent: "space-between",
              paddingHorizontal: 10,
            }}
          >
            {[
              { key: "client", label: t("clientHeader-string"), width: "21%" },
              {
                key: "block",
                label: t("blockHeader-string"),
                width: "13%",
              },
              { key: "week", label: t("weekHeader-string"), width: "12%" },
            ].map(({ key, label, width }) => (
              <TouchableOpacity
                key={key}
                onPress={() => coach.setProperty("sortTerm", key)}
                style={{
                  width,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FontAwesome
                  name="sort"
                  size={12}
                  color="rgb(108, 115, 127)"
                  style={{ marginRight: 5, opacity: 0 }}
                />
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {label}
                </Text>
                <FontAwesome
                  name="sort"
                  size={12}
                  color="rgb(108, 115, 127)"
                  style={{
                    marginLeft: 5,
                    opacity: coach.sortTerm === key ? 1 : 0,
                  }}
                />
              </TouchableOpacity>
            ))}

            <View style={{ width: "42%", alignItems: "center" }}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {t("workoutsOfWeekHeader-string")}
                </Text>
                <Tooltip
                  content="workoutsOfWeekTooltip-string"
                  placement="top"
                  maxWidth={300}
                >
                  <View
                    style={[styles.tooltipIconContainer, { marginLeft: 4 }]}
                  >
                    <Ionicons
                      name="information-circle-outline"
                      size={16}
                      color={"rgb(108, 115, 127)"}
                    />
                  </View>
                </Tooltip>
              </View>
              <View
                style={{
                  height: 1,
                  backgroundColor: Colors.borderColor,
                  width: "100%",
                  marginVertical: 5,
                }}
              />
              <View
                style={{
                  ...GlobalStyles.HStack,
                  width: "100%",
                }}
              >
                {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map(
                  (day) => (
                    <TouchableOpacity
                      key={day}
                      onPress={() =>
                        coach && coach.setProperty("sortTerm", day)
                      }
                      style={{
                        width: "14.28%",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FontAwesome
                        name="sort"
                        size={12}
                        color="rgb(108, 115, 127)"
                        style={{
                          marginRight: 5,
                          opacity: 0,
                        }}
                      />
                      <Text
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          fontWeight: "600",
                          color: "rgb(108, 115, 127)",
                        }}
                      >
                        {t(`${day}Header-string`).toUpperCase()}
                      </Text>
                      <FontAwesome
                        name="sort"
                        size={12}
                        color="rgb(108, 115, 127)"
                        style={{
                          marginLeft: 5,
                          opacity: coach.sortTerm === day ? 1 : 0,
                        }}
                      />
                    </TouchableOpacity>
                  )
                )}
              </View>
            </View>

            <TouchableOpacity
              onPress={() => coach.setProperty("sortTerm", "status")}
              style={{
                width: "12%",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FontAwesome
                name="sort"
                size={12}
                color="rgb(108, 115, 127)"
                style={{ marginRight: 5, opacity: 0 }}
              />
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  fontWeight: "600",
                  color: "rgb(108, 115, 127)",
                }}
              >
                {t("statusHeader-string")}
              </Text>
              <FontAwesome
                name="sort"
                size={12}
                color="rgb(108, 115, 127)"
                style={{
                  marginLeft: 5,
                  opacity: coach.sortTerm === "status" ? 1 : 0,
                }}
              />
            </TouchableOpacity>
          </View>
        </View>
      );
    });

    const EmptySearchState = () => {
      return (
        <View
          style={{
            backgroundColor: "white",
            borderBottomRightRadius: 14,
            borderBottomLeftRadius: 14,
            borderRightWidth: 0.1,
            borderLeftWidth: 0.1,
            borderBottomWidth: 0.1,
            borderColor: Colors.borderColor,
          }}
        >
          <IconEmptyView
            iconLibrary={"Ionicons"}
            mainText={"emptyClientsTitle-string"}
            subText={"noAthletesFoundText-string"}
            iconName={"search-outline"}
            marginTop={48}
            marginBottom={16}
          />
        </View>
      );
    };

    const ClientRow = observer(({ client, index }) => {
      const RenderCircles = observer(() => {
        return client.weekWorkouts.map((hasWorkout, index) => {
          let circleStyle = {
            borderWidth: 0.5,
            borderColor: Colors.bubbleColor,
            backgroundColor: "transparent", // Default to transparent
          };

          if (hasWorkout) {
            circleStyle.backgroundColor = Colors.bubbleColor; // Filled circle for workout days
          } else {
            circleStyle.borderWidth = 1; // Only border for days without a workout
          }

          const toggleWorkoutDay = () => {
            if (coach.isActive && !coach.isOffline) {
              const updatedWorkouts = [...(client && client.weekWorkouts)];
              updatedWorkouts[index] = !updatedWorkouts[index];
              client.setProperty("weekWorkouts", updatedWorkouts);
              client.uploadData({
                week_workouts: updatedWorkouts,
              });
            }
          };

          const [isHovered, setIsHovered] = useState(false);

          return (
            <TouchableOpacity
              key={index}
              onPress={toggleWorkoutDay}
              style={{
                flexDirection: "row",
                height: "100%",
                width: "14.28%",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <View
                style={[
                  styles.circle,
                  circleStyle,
                  { opacity: isHovered ? 0.8 : 1 },
                ]}
              />
            </TouchableOpacity>
          );
        });
      });

      const clientSelection = () => {
        if (coach.isActive) {
          if (client.isAvailable) {
            if (client.status === "active-string") {
              selectClient(client.id);
            } else if (client.status != "active-string") {
              console.log("client.status === pending-string:", client.status);

              setClientToDelete(client);
              setShowingDeleteAlert(true);
            }
            console.log("client.status:", client.status);
          } else {
            //popup de offline
            setShowingOfflineAlert(true);
          }
        }
      };

      const [isHovered, setIsHovered] = useState(false);
      return (
        <TouchableOpacity
          onPress={clientSelection}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              backgroundColor: isHovered ? Colors.hoveredGray : "white",
              height: 50,
              borderBottomRightRadius:
                index === coach.getFilteredClients().length - 1 ? 14 : 0,
              borderBottomLeftRadius:
                index === coach.getFilteredClients().length - 1 ? 14 : 0,
              borderTopWidth: index === 0 ? 0 : 0.1,
              borderRightWidth: 0.1,
              borderLeftWidth: 0.1,
              borderBottomWidth:
                index === coach.getFilteredClients().length - 1 ? 0.1 : 0,
              borderColor: Colors.borderColor,
              alignItems: "center",
            }}
          >
            <View
              style={[
                GlobalStyles.HStack,
                {
                  width: "100%",
                  paddingHorizontal: 10,
                  flex: 1,
                  // justifyContent: "space-between",
                },
              ]}
            >
              <View style={{ width: "21%" }}>
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color: Colors.blackColor,
                      fontWeight: "500",
                    },
                  ]}
                  numberOfLines={2}
                >
                  {client.nameForCoach} {client.surnameForCoach}
                </Text>
              </View>

              <View style={{ width: "13%" }}>
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color:
                        client.status != "active-string" ||
                        client.getBlockCurrentName == "-"
                          ? Colors.grayColor
                          : Colors.blackColor,
                      fontWeight: "500",
                    },
                  ]}
                  numberOfLines={1}
                >
                  {client.status === "active-string"
                    ? client.getBlockCurrentName != null
                      ? client.getBlockCurrentName
                      : "-"
                    : "-"}
                </Text>
              </View>

              <View style={{ width: "12%" }}>
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color:
                        client.status != "active-string" ||
                        (client.getBlockWeeks === 0 &&
                          client.getBlockCurrentWeek === 0)
                          ? Colors.grayColor
                          : Colors.blackColor,
                      fontWeight: "500",
                    },
                  ]}
                >
                  {client.status === "active-string"
                    ? client.getBlockWeeks === 0 &&
                      client.getBlockCurrentWeek === 0
                      ? "-"
                      : `${client.getBlockCurrentWeek} / ${client.getBlockWeeks}`
                    : "-"}
                </Text>
              </View>

              <View
                style={[
                  GlobalStyles.HStack,
                  {
                    width: "42%",
                  },
                ]}
              >
                <RenderCircles />
              </View>
              <View style={{ width: "12%", alignItems: "center" }}>
                {(() => {
                  const StatusPill = () => {
                    const isActive = client.status === "active-string";
                    const isError = client.status === "error-string";
                    const isPending = client.status === "pending-string";

                    let color, backgroundColor;

                    if (isActive) {
                      color = "#15803d";
                      backgroundColor = "rgba(22, 163, 74, 0.1)";
                    } else if (isError) {
                      color = "#b91c1c";
                      backgroundColor = "rgba(220, 38, 38, 0.1)";
                    } else if (isPending) {
                      color = "#d97706";
                      backgroundColor = "rgba(234, 179, 8, 0.1)";
                    }

                    const pillContent = (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: backgroundColor,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: color,
                            marginRight: 6,
                          }}
                        />
                        <Text
                          style={[
                            Fonts.regular12,
                            {
                              color: color,
                              fontWeight: "500",
                            },
                          ]}
                        >
                          {isActive
                            ? t("active-string")
                            : isError
                            ? t("error-string")
                            : t("pending-string")}
                        </Text>
                      </View>
                    );

                    if (isError) {
                      return (
                        <Tooltip
                          content="invitationErrorTooltip-string"
                          placement="top"
                          maxWidth={300}
                        >
                          {pillContent}
                        </Tooltip>
                      );
                    }

                    if (isPending) {
                      return (
                        <Tooltip
                          content="invitationPendingTooltip-string"
                          placement="top"
                          maxWidth={300}
                        >
                          {pillContent}
                        </Tooltip>
                      );
                    }

                    return pillContent;
                  };

                  return <StatusPill />;
                })()}
              </View>
            </View>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <ScrollView
        horizontal={true}
        style={{
          width: "100%",
          flexDirection: "row",
        }}
        contentContainerStyle={{ flex: 1 }}
        showsHorizontalScrollIndicator={false}
      >
        <View
          style={{
            minWidth: 800,
            flex: 1,
          }}
        >
          <ClientTableHeader />
          <Observer>
            {() => {
              const filteredClients = coach.getFilteredClients();
              return filteredClients.length > 0 ? (
                filteredClients.map((client, index) => (
                  <View key={client.id}>
                    <ClientRow client={client} key={client.id} index={index} />
                  </View>
                ))
              ) : (
                <EmptySearchState />
              );
            }}
          </Observer>
        </View>
      </ScrollView>
    );
  };

  return (
    <View style={[styles.container, {}]}>
      <View>
        <Observer>
          {() => (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <>
                  <Text
                    style={[
                      styles.title,
                      { marginRight: screenSize === "small" ? 8 : 12 },
                    ]}
                    // onPress={() => coach.changeClientNamesDemo("en", i18n)}
                  >
                    {t("helloCoach-string", { coachName: coach.name })}
                  </Text>
                  {/* <TouchableOpacity onPress={fetchPolClient}>
                    <Text>FETCHPOL</Text>
                  </TouchableOpacity> */}
                  {/* <TouchableOpacity
                    onPress={() => coach.createCoachDemoClient()}
                  >
                    <Text>fetch demo</Text>
                  </TouchableOpacity> */}
                  {coach.syncStatusManager.syncStatus != SyncStatus.SYNCED && (
                    <SyncStatusIndicator
                      syncStatusManager={coach.syncStatusManager}
                      onPress={() => coach.startOrResetBatchTimer()}
                    />
                  )}
                </>
              </View>

              <LogoImage coach={coach} />
            </View>
          )}
        </Observer>

        <Observer>
          {() => {
            const showNextCompetitions = !coach.sidebarConfig?.some(
              (item) =>
                item.id === "CoachCompetitions" && item.visible === false
            );
            return (
              <View
                style={[
                  screenSize !== "small" && GlobalStyles.HStack,
                  {
                    justifyContent: "space-between",
                    marginTop: screenSize === "small" ? 12 : 20,
                    marginBottom: screenSize === "small" ? 16 : 24,
                    gap: gap,
                  },
                ]}
              >
                {showNextCompetitions ? (
                  <>
                    <View
                      style={[
                        {
                          flex: 1,
                          width: screenSize === "small" ? "100%" : "50%",
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: screenSize === "small" ? 180 : 180,
                          marginBottom: gap,
                        }}
                      >
                        <CheckedClients />
                      </View>
                      <View
                        style={[
                          GlobalStyles.HStack,
                          {
                            gap: gap,
                            height: 110,
                          },
                        ]}
                      >
                        <View
                          style={{
                            flex: 1,
                            height: "100%",
                          }}
                        >
                          <LastWeekClients />
                        </View>
                        <View
                          style={{
                            flex: 1,
                            height: "100%",
                          }}
                        >
                          <PreviousWeekClients />
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        width: screenSize === "small" ? "100%" : "50%",
                        height:
                          screenSize === "small" ? "auto" : 180 + gap + 110,
                      }}
                    >
                      <NextCompetitions />
                    </View>
                  </>
                ) : (
                  <>
                    <View
                      style={[
                        {
                          flex: 1.3,
                          height: screenSize === "small" ? "auto" : "100%",
                        },
                      ]}
                    >
                      <CheckedClients />
                    </View>
                    <View style={screenSize !== "small" ? { flex: 1 } : {}}>
                      <View
                        style={{
                          height: 100,
                          marginBottom: gap,
                        }}
                      >
                        <LastWeekClients />
                      </View>
                      <View
                        style={{
                          height: 100,
                        }}
                      >
                        <PreviousWeekClients />
                      </View>
                    </View>
                  </>
                )}
              </View>
            );
          }}
        </Observer>

        <View style={[GlobalStyles.HStack, { maxWidth: "60%" }]}>
          <Observer>
            {() => (
              <SearchBar
                text={coach.searchTerm}
                onChangeText={(text) => coach.setSearchTerm(text)}
                dark={false}
                placeholder={"searchClient-string"}
              />
            )}
          </Observer>
          <CTAButton
            plus={true}
            text={"addClient-string"}
            action={() => {
              if (coach.isActive && !coach.isOffline) {
                setShowingAddClient(true);
              }
            }}
            disabled={coach.isOffline}
          />
        </View>
        <ClientsTable />

        {showingOfflineAlert && (
          <OfflineAlert
            isVisible={showingOfflineAlert}
            onClose={() => setShowingOfflineAlert(false)}
          />
        )}

        {showingAddClient && (
          <AddNewClientView
            isVisible={showingAddClient}
            onClose={() => setShowingAddClient(false)}
            coach={coach}
            setShowingMaxClientsReached={() =>
              setShowingMaxClientsReached(true)
            }
            setShowingMaxClientsTrial={() => setShowingMaxClientsTrial(true)}
          />
        )}
        {showingStripePayment && (
          <StripePayment
            isVisible={showingStripePayment}
            onClose={() => setShowingStripePayment(false)}
            coach={coach}
          />
        )}
        {showingMaxClientsReached && (
          <StripePayment
            isVisible={showingMaxClientsReached}
            onClose={() => setShowingMaxClientsReached(false)}
            coach={coach}
            maxClientsReached={true}
          />
        )}
        {showingMaxClientsTrial && (
          <StripePayment
            isVisible={showingMaxClientsTrial}
            onClose={() => setShowingMaxClientsTrial(false)}
            coach={coach}
            maxClientsTrial={true}
          />
        )}
        {showingDeleteAlert && (
          <CustomAlert
            isVisible={showingDeleteAlert}
            onClose={() => setShowingDeleteAlert(false)}
            title={deleteAlertTitle}
            text={deleteAlertText}
            action={deleteInvitation}
            specialCTA={"delete-string"}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  title: {
    fontSize: 24,
    fontWeight: "650",
  },
  subtitle: {
    fontSize: 14,
    fontWeight: "500",
    color: "rgb(140, 140, 140)",
  },
  tabText: {
    fontSize: 20,
    fontWeight: "500",
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 5,
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: 50, // Half of the width/height
    marginHorizontal: 8,
  },
  textInputStyle: {
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 14,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    borderRadius: 14,
    height: 40,
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
  },
  colorCircle: {
    width: 8,
    height: 8,
    borderRadius: 7.5,
    marginRight: 5,
  },
  competitionRow: {
    backgroundColor: "rgba(63, 123, 141, 0.04)",
    borderRadius: 12,
    borderWidth: 0.1,
    marginHorizontal: 14,
    // marginBottom: 8,
    justifyContent: "space-between",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.05)",
  },
  tooltipIconContainer: {
    marginLeft: 8,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default CoachDashboard;
